function getStateWithExpiry(key: string) {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}

export const saveStateToLocalStorage = (state, localStorageKey: string) => {
  try {
    const ttl = 86400000; // one day expiry limit
    const now = new Date();

    const item = {
      value: state,
      expiry: now.getTime() + ttl,
    };

    const serializedState = JSON.stringify(item);

    localStorage.setItem(localStorageKey, serializedState);
  } catch (e) {
    console.error('[saveStateToLocalStorage.error]', e.message);
  }
};

export const getStateFromLocalStorage = (localStorageKey: string) => {
  try {
    return getStateWithExpiry(localStorageKey);
  } catch (e) {
    console.error('[getStateFromLocalStorage.error]', e.message);
    return null;
  }
};

export const deleteKeyFromWebStorage = storageKey => {
  console.log(`[utils.deleteStateFromWebStorage]: Local storage deleted for key ${storageKey}`);
  localStorage.removeItem(storageKey);
};
